import React from "react";
import styles from "./ValidationError.module.scss";

interface ValidationErrorProps {
  validateError: boolean;
  submitError: string;
}

export const ValidationError: React.FC<ValidationErrorProps> = ({
  validateError,
  submitError,
}) => {
  const validateErrorText = (error: string) => {
    if (error.includes("Missing partner_id")) {
      return "Идентификатор партнера не найден";
    }
    return error;
  };

  if (submitError) {
    return (
      <div className={styles.error}>
        <p className={styles.errorText}>{validateErrorText(submitError)}</p>
      </div>
    );
  }

  if (validateError) {
    return (
      <div className={styles.error}>
        <p className={styles.errorText}>Заполните все обязательные поля</p>
      </div>
    );
  }

  return null;
};

